export const FETCH_OFFER_BY_ID_REQUEST = 'FETCH_OFFER_BY_ID_REQUEST';
export const FETCH_OFFER_BY_ID_SUCCESS = 'FETCH_OFFER_BY_ID_SUCCESS';
export const FETCH_OFFER_BY_ID_FAILURE = 'FETCH_OFFER_BY_ID_FAILURE';
export const FETCH_OFFER_CLEAN_UP = 'FETCH_OFFER_CLEAN_UP';
